<template>
    <Card bordered style="width:290px;background-image: linear-gradient(#70a1ff, #c7ecee) ">
        <p slot="title" style="display: flex;justify-content: space-between">
            <span>{{$t('l.lift_permission')}}</span>
            <span>
                <Tooltip transfer :content="isFace==0?$t('l.hint28'):$t('l.hint29')" placement="top">
                    <i-switch style="margin-right: 10px" @on-change="onChangeFace" :value="isFace==0"
                              size="small"></i-switch>
                </Tooltip>
                <Tooltip transfer :content="isCode==0?$t('l.hint30'):$t('l.hint31')" placement="top">
                    <i-switch style="margin-right: 10px" :value="isCode==0" @on-change="onChangeQr"
                              size="small"></i-switch>
                </Tooltip>
                <Tooltip transfer :content="$t('l.delete')" placement="top">
                    <Icon class="delete-icon" type="ios-trash-outline"  @click="deleteKey"/>
                </Tooltip>
            </span>
        </p>
        <Row class="row">
            <Col span="24">
                <p>{{$t('l.location')}}：{{community.name}}{{building}}{{keyInfo.floorText}}</p>
                <p>{{$t('l.the_term')}}：
                    <DatePicker transfer placement="top" :clearable="false" @on-change="change"
                                v-model="keyInfo.end_time" format="yyyy-MM-dd" type="date" :placeholder="$t('l.hint32')"
                                style="width: 200px"></DatePicker>
                </p>
                <p style="display: flex;align-items: center">{{$t('l.remark50')}}：
                    <InputNumber v-model="keyInfo.limit_day" @on-change="changeInput" :placeholder="$t('l.times')"/>
                </p>
            </Col>
        </Row>
    </Card>
</template>

<script>

    import util from "../../../libs/util"

    export default {
        name: "qr-key",
        props: {
            keyInfo: Object,
            buildings: Array,
            keys: Array
        },
        data() {
            return {
                deviceList: [],
                community: {}
            }
        },
        methods: {
            changeInput(v) {
                this.$emit("changeLimitDay", this.keyInfo, v)
            },
            change(v, t) {
                this.$emit("changeEndTime", this.keyInfo, v)
            },
            deleteKey() {
                this.$emit("deleteKey", this.keyInfo)
            },
            onChangeQr(val) {
                this.$emit("disabledQr", val, this.keyInfo);
            },
            onChangeFace(val) {
                this.$emit("disabledFace", val, this.keyInfo);
            },
        },
        computed: {
            building() {
                let build = this.buildings.find(item => (item.id == this.keyInfo.location[1]))
                if (build) {
                    let unit = build.children.find(elem => (elem.id == this.keyInfo.location[2]))
                    return build?build.name:'' + unit?unit.name:'';
                }
                return "";
            },
            isFace() {
                return this.keyInfo.is_device.face
            },
            isCode() {
                return this.keyInfo.is_device.qr
            }
        },
        mounted() {
            this.community = JSON.parse(localStorage.getItem("current_community"));
        },
    }
</script>

<style scoped lang="less">
    .row {
        p {
            margin: 5px 0;
        }
    }
    .delete-icon{
        cursor: pointer;
        font-size: 20px;
    }

</style>